import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import GameplayView from "../views/gameplay/gamePlayView.jsx";
import {
  kelvinToCelsius,
  calculateGravity,
  calculateMassFormatted,
} from "../utilities";

const GameplayPresenter = observer(function GameplayRender(props) {
  const navigate = useNavigate();

  if (!!props.model.currentPlanet) {
    const planet = props.model.currentPlanet;
    if (props.model.currentRound == null) props.model.initializeGame();
    return (
      <GameplayView
        round={props.model.currentRound}
        setSize={setSizeACB}
        onSliderChange={setDistanceACB}
        onSizeChange={setSizeACB}
        toResults={toResultsACB}
        planet={planet}
        kelvinToCelsius={kelvinToCelsius}
        calculateGravity={calculateGravity}
        calculateMass={calculateMassFormatted}
        guessedValues={props.model.guessedValues}
      ></GameplayView>
    );
  } else
    return (
      <div>
        An error occurred.{" "}
        <button className="btn-primary" onClick={toHomeACB}>
          Home
        </button>
      </div>
    );

  function setSizeACB(value) {
    props.model.setSize(value);
  }

  //distanceHandler
  function setDistanceACB(value) {
    props.model.setDistance(value);
  }

  function toResultsACB() {
    navigate("/results", { replace: true });
  }
  function toHomeACB() {
    navigate("/home");
  }
});

export { GameplayPresenter };
